import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import AppRoutes from '../../constants/AppRoutes';
import Messages from '../../constants/Messages';

const CartHighlighter = (props) => {
    const {
        count, cartTotalValue
    } = props;

    return (
        <>
        {
            count > 0 ? (
                <Link to={AppRoutes.CART}>
                    <div className="w-11/12 mx-auto max-w-lg inset-x-0 rounded-lg flex p-4 text-sm bg-black text-white justify-content align-items fixed bottom-5">
                        <div className="basis-2/3">
                            <span className=''>{count} { count > 1 ? Messages.CART.CART_HIGHLIGHTER.ITEMS : Messages.CART.CART_HIGHLIGHTER.ITEM} | </span>
                            <span className='font-medium'>{Messages.CURRENCY.INR} {cartTotalValue}</span>
                        </div>
                        <div className="basis-1/3 text-right font-bold">
                            {Messages.CART.CART_HIGHLIGHTER.VIEW_CART}
                        </div>
                    </div>
                </Link>
            ) : null
        }
        </>
    )
}

CartHighlighter.propTypes = {
    count: PropTypes.number,
    cartTotalValue: PropTypes.number
};

export default CartHighlighter;